import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Tree, Table, Empty, Checkbox } from 'antd';
import moment from 'moment';
import './styles.css';
import TextArea from "antd/lib/input/TextArea";

import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';


const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModalVer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    render() {

        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        return (
            <Modal
                title="Ver Fondo Fijo"
                visible={this.props.visible}
                style={{ top: 30 }}
                onCancel={this.handleCancel}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cerrar
                    </Button>
                ]}
                style={{ top: 30 }}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("documento", {
                                            initialValue: this.props.formValues.documento,
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("fechaStr", {
                                            initialValue: moment(
                                                this.props.formValues.fechaStr,
                                                "DD/MM/YYYY"),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon type="filter" style={{ color: "rgba(0,0,0,.25)" }} />
                                                }
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => this.props.onChange('fechaStr', value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("tipoCambio", {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)",
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "tipoCambio",
                                                        e.target.value
                                                    )}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Días / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("diasVencimiento", {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_NUMBER),
                                                    message: "Formato incorrecto",
                                                },
                                            ],
                                        })(
                                            <Input
                                                style={{ textAlign: "right" }}
                                                placeholder="Ingresar días de vencimiento"
                                                autoComplete="off"
                                                className="first-input"
                                                onBlur={(e) =>
                                                    this.findDaysAndDates(
                                                        "diasVencimiento",
                                                        e.target.value
                                                    )}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("fechaVencimientoStr", {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, "DD/MM/YYYY"),
                                            rules: [{
                                                type: "object",
                                                required: true,
                                                message: "Requerido",
                                            }]
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                onChange={(moment, value) =>
                                                    this.findDaysAndDates("fechaVencimientoStr", value)
                                                }
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.nombreEstablecimientoSucursal
                                })(
                                    < Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Centro de Costo">
                                {getFieldDecorator('nombreCentroCosto', {
                                    initialValue: this.props.formValues.nombreCentroCosto
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Saldo Inicial Soles">
                                {getFieldDecorator("saldoInicialSoles", {
                                    initialValue: parseFloat(
                                        this.props.formValues.saldoInicialSoles
                                    ).toFixed(2),
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-8 form-group">
                            <Form.Item label="Responsable">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator('empleado', {
                                            initialValue: this.props.formValues.empleado
                                        })(
                                            <Input readOnly={true} />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Saldo Inicial Dólares">
                                {getFieldDecorator("saldoInicialDolares", {
                                    initialValue: parseFloat(
                                        this.props.formValues.saldoInicialDolares
                                    ).toFixed(2),
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator("observacion", {
                                    initialValue: this.props.formValues.observacion,
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(FormModalVer)